import React, { useState, useEffect, useRef } from 'react';
import "./SingleSelect.css";
import BodySmallRegular from './BodySmallRegular';
import { Search, ChevronDown } from "lucide-react";
import { CircleAlert } from "lucide-react";

const SingleSelect = ({ options, value, onChange, disabled = false, placeholder = 'Select',tooltipExample,tooltipFormat,labelIconRight , label, isSearchable, secondaryLabel, type, icon, iconStart, iconEnd, error, labelIcon }) => {
    const [selectedOption, setSelectedOption] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const dropdownRef = useRef(null);
    const inputRef = useRef(null);
    const searchInputRef = useRef(null);
    const [filteredOptions, setFilteredOptions] = useState(options);
    const [showTooltip, setShowTooltip] = useState(false);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (inputRef.current && inputRef.current.contains(event.target)) {
                setIsOpen((prev) => !prev);
            } else if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);
 useEffect(() => {
        if (isOpen) {
            // Clear any text selection when dropdown opens
            if (window.getSelection) {
                window.getSelection().removeAllRanges();
            }
            if (isSearchable && searchInputRef.current) {
                setTimeout(() => {
                    searchInputRef.current.focus();
                }, 10);
            }
            
            // Prevent text selection outside dropdown while it's open
            const preventSelection = (e) => {
                 if (searchInputRef.current && !searchInputRef.current.contains(e.target) &&
                    dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                    e.preventDefault();
                }
            };
            
            document.addEventListener('selectstart', preventSelection);
            return () => document.removeEventListener('selectstart', preventSelection);
        }
        
        // Clear search query when dropdown closes
        if (!isOpen) {
            setSearchQuery('');
        }
    }, [isOpen, isSearchable]);
  useEffect(() => {
        if (searchQuery.trim()) {
            const lowerCaseQuery = searchQuery.toLowerCase();
            setFilteredOptions(
                options?.filter(option => 
                    option.label.toLowerCase().includes(lowerCaseQuery)
                )
            );
        } else {
            setFilteredOptions(options);
        }
    }, [searchQuery, options]);
    useEffect(() => {
        if (value && options?.length > 0) {
            const matchedOption = options.find(option => option.value == value);
            setSelectedOption(matchedOption ? matchedOption.label : '');
        } else {
            setSelectedOption('');
        }
    }, [value, options]);

    const handleOptionClick = (option) => {
        setSelectedOption(option.label);
        onChange(option, label);
        setIsOpen(false);
    };

    const handleSearchInput = (e) => {
        e.stopPropagation();
        setSearchQuery(e.target.value);
    };

    return (
        <div className={`custom-single-select-container ${disabled ? 'custom-disabled' : ''}`}>
            <div className='single-select-main'>
                <div className='custom-single-select-label-container'>
                    {labelIcon && labelIcon}
                    {label && label.length !== 0 && (
                        <div className="label-with-icons">
                            {label && <BodySmallRegular color="#1E293B" text={label} />}
                            {labelIconRight && (
                                <div
                                    className="icon-with-tooltip"
                                    onMouseEnter={() => setShowTooltip(true)}
                                    onMouseLeave={() => setShowTooltip(false)}
                                >
                                    {labelIconRight}
                                    {showTooltip && (tooltipFormat || tooltipExample) && (
                                        <div className="tooltip-box">
                                            {tooltipFormat && (
                                                <div className="tooltip-row">
                                                    <span className="tooltip-heading">Format:</span>
                                                    <span className="tooltip-text">{tooltipFormat}</span>
                                                </div>
                                            )}
                                            {tooltipExample && (
                                                <div className="tooltip-row">
                                                    <span className="tooltip-heading">Example:</span>
                                                    <span className="tooltip-text">{tooltipExample}</span>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    )}
                </div>

                <div className='custom-single-select-div'>
                    <div className="custom-single-select" ref={inputRef}>
                        <span className='main-label-container'>{selectedOption || placeholder}</span>
                        <span className="custom-single-select-icon">
                            {icon ? icon : <ChevronDown />}
                        </span>
                    </div>
                    {typeof error === "string" && error.trim().length > 0 && (
                        <div className="error-single-select-container">
                            <CircleAlert height={16} />
                            <span className="single-select-error-text">
                                {error && <p>{error}</p>}
                            </span>
                        </div>
                    )}
                </div>
            </div>

            {isOpen && (
                <div className="custom-single-select-dropmenu-container" ref={dropdownRef}>
                    {options && options.length > 0 ? (
                        <>
                            {isSearchable && (
                                <div className='custom-single-select-search-container'>
                                    <input
                                        ref={searchInputRef}
                                        className='search-input'
                                        placeholder='Search'
                                        value={searchQuery}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                        }}
                                        onMouseDown={(e) => {
                                            e.stopPropagation();
                                        }}
                                        onKeyDown={(e) => {
                                            e.stopPropagation();
                                        }}
                                        onFocus={(e) => {
                                            e.stopPropagation();
                                               if (document.getSelection) {
                                                document.getSelection().empty();
                                            }
                                        }}
                                        onChange={handleSearchInput}
                                    />
                                    <Search width={18} />
                                </div>
                            )}
                            <div className="custom-single-select-options">
                                {filteredOptions && filteredOptions.length > 0 ? filteredOptions.map((option) => (
                                    <div
                                        key={option.value}
                                        className="custom-single-select-option"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleOptionClick(option);
                                        }}
                                    >
                                        <div className='primary-label-div'>
                                            {type && type === "radio" && (
                                                <input
                                                    type="radio"
                                                    className="custom-radio-input"
                                                    checked={value === option.value}
                                                    readOnly
                                                />
                                            )}
                                            {iconStart && iconStart}
                                            <span className='label-text'>{option.label}</span>
                                        </div>
                                        {secondaryLabel && option.secondaryLabel && (
                                            <span className='secondary-label'>{option.secondaryLabel}</span>
                                        )}
                                        {iconEnd && iconEnd}
                                    </div>
                                )) : (
                                    <div className="custom-single-select-option">
                                        <span>No data</span>
                                    </div>
                                )}
                            </div>
                        </>
                    ) : (
                        <div className="custom-single-select-option">
                            <span>No data</span>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};
export default SingleSelect;